"use strict";

var _themeLocalStorage = require("../helpers/theme-local-storage");

document.addEventListener("DOMContentLoaded", function () {
  /*----------------------------
  Show dismissible notifications on page load
  All dismissible notifications are hidden by default using css.
  ----------------------------*/

  function showDismissibleNotifications() {
    // Capture all of the dismissible notifications on the page

    var dismissibleNotifications = document.querySelectorAll(".notification--is-dismissible");

    // Save our local storage array which indicates which banners have already been hidden

    var themeLocalStorage = (0, _themeLocalStorage.getThemeLocalStorage)("hiddenNotifications");

    Array.from(dismissibleNotifications).forEach(function (notification) {
      // Check if the notification is in our hidden array in local storage. If not, then show it.

      var notificationName = notification.id;

      if (!themeLocalStorage.hiddenNotifications.includes(notificationName)) {
        notification.style.display = "block";
      }
    });
  }

  showDismissibleNotifications();

  /*----------------------------
  Dismiss Notifications
  ----------------------------*/

  // Capture all of the dismiss buttons on the page and loop through them.

  var dismissButtons = document.querySelectorAll(".notification__dismiss-btn");

  Array.from(dismissButtons).forEach(function (button) {
    // Save the notification that is associated with this button.
    var notificationName = button.dataset.dismiss;
    var notificationElement = document.querySelector("#" + notificationName);

    // Click action on this button

    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Hide the notification from the page.
      notificationElement.style.display = "none";

      // Indicate in local storage that this notification has been hidden.
      // Get the current array of hidden notifications from local storage.
      var themeLocalStorage = (0, _themeLocalStorage.getThemeLocalStorage)("hiddenNotifications");

      themeLocalStorage.hiddenNotifications.push(notificationName);

      // Set local storage with the new array info.
      (0, _themeLocalStorage.setThemeLocalStorage)(themeLocalStorage);
    });
  });
}); /*-------------------------------
    Imports
    -------------------------------*/